import { processDocument } from '@/features/documents/utils';

export const formatClient = (cliente) => {
  const attributes = {};
  const relationships = {};
  if (!cliente.title || cliente.title === '') {
    if (cliente.apellidos !== '') {
      attributes.title = `${cliente.apellidos} - ${cliente.nombre}`;
    } else {
      attributes.title = cliente.nombre;
    }
  } else {
    attributes.title = cliente.title;
  }
  if (cliente.dni) {
    attributes.dni = cliente.dni;
  }
  if (cliente.nombre) {
    attributes.nombre = cliente.nombre;
  }
  if (cliente.apellidos) {
    attributes.apellidos = cliente.apellidos;
  }
  if (cliente.cp) {
    attributes.codigo_postal_cliente = cliente.cp;
  }
  if (cliente.poblacion) {
    attributes.poblacion = cliente.poblacion;
  }
  if (cliente.provincia) {
    attributes.provincia = cliente.provincia;
  }
  if (cliente.tel1) {
    attributes.tlfno_1 = cliente.tel1;
  }
  if (cliente.tel2) {
    attributes.tlfno_2 = cliente.tel2;
  }
  if ('deudor' in cliente) {
    attributes.deudor = cliente.deudor;
  }
  if ('hipotecante' in cliente) {
    attributes.hipotecante = cliente.hipotecante;
  }
  if (cliente.direccion) {
    attributes.direccion = cliente.direccion;
  }
  if (cliente.email) {
    attributes.e_mail = cliente.email;
  }
  if (cliente.observaciones) {
    attributes.comentario = cliente.observaciones;
  }
  if (cliente.rating) {
    attributes.rating = cliente.rating;
  }
  let relData = {};
  if (cliente.tipo) {
    relData = {
      type: 'taxonomy_term--person',
      id: cliente.tipo,
    };
    relationships.person = {
      data: relData,
    };
  }
  if (cliente.estadoCivil) {
    relData = {
      type: 'taxonomy_term--civil_state',
      id: cliente.estadoCivil,
    };
    relationships.civil_state = {
      data: relData,
    };
  }
  if (cliente.contact) {
    relationships.contacto = {
      data: {
        type: 'node--contacto',
        id: cliente.contact.id,
      },
    };
  }
  if (cliente.reputations) {
    const reputationsData = [];
    cliente.reputations.forEach((reputation) => {
      reputationsData.push({
        type: 'node--online_reputation',
        id: reputation.id,
      });
    });
    relationships.reputations = {
      data: reputationsData,
    };
  }
  const id = 'id' in cliente && cliente.id !== 'dummy' ? cliente.id : undefined;
  return {
    data: {
      type: 'node--client',
      id,
      attributes,
      relationships,
    },
  };
};
export const formatReputation = (reputation) => {
  const attributes = {};
  const relationships = {};
  if (reputation.url && reputation.url !== '') {
    attributes.title = reputation.url;
  }
  if (reputation.comentarios) {
    attributes.comentario = reputation.comentarios;
  }
  if (reputation.document && reputation.document.id && reputation.document.id !== 'dummy') {
    relationships.document = {
      data: {
        type: 'node--document',
        id: reputation.document.id,
      },
    };
  }
  const id = 'id' in reputation && reputation.id !== 'dummy' ? reputation.id : undefined;
  return {
    data: {
      id,
      type: 'node--online_reputation',
      attributes,
      relationships,
    },
  };
};

export const formatContact = (contact) => {
  const attributes = {};
  if (contact.title) {
    attributes.title = contact.title;
  } else {
    attributes.title = `${contact.nombre} - ${contact.apellidos}`;
  }
  if (contact.dni) {
    attributes.dni_contacto = contact.dni;
  }
  if (contact.email) {
    attributes.email = contact.email;
  }
  if (contact.nombre) {
    attributes.nombre_contacto = contact.nombre;
  }
  if (contact.apellidos) {
    attributes.apellidos_contacto = contact.apellidos;
  }
  if (contact.cargo) {
    attributes.cargo_contacto = contact.cargo;
  }
  if (contact.tel1) {
    attributes.tel1 = contact.tel1;
  }
  if (contact.tel2) {
    attributes.tel2 = contact.tel2;
  }
  const id = 'id' in contact && contact.id !== 'dummy' ? contact.id : undefined;
  return {
    data: {
      type: 'node--contacto',
      id,
      attributes,
    },
  };
};

export const processReputationIncluded = (reputation, included) => {
  let document = null;
  const { relationships } = reputation;
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--document') {
        if (relationships &&
          relationships.document &&
          relationships.document.data &&
          relationships.document.data.id === rel.id) {
          document = processDocument(rel);
        }
      }
    });
  }
  return { document };
};

export const processReputation = (data, included) => {
  let clientModel = null;
  if (data && data.id) {
    clientModel = {};
    clientModel.id = data.id;
    clientModel.type = data.type;
    const { attributes, relationships } = data;
    if (attributes.title) {
      clientModel.url = attributes.title;
    }
    if (attributes.comentario) {
      clientModel.comentarios = attributes.comentario;
    }
    if (relationships.document &&
      relationships.document.data) {
      if (included && included.document) {
        clientModel.document = included.document;
      } else {
        clientModel.document = relationships.document.data.id;
      }
    }
  }
  return clientModel;
};

export const processContact = (data) => {
  let contactoModel = null;
  if (data && data.id) {
    contactoModel = {};
    contactoModel.id = data.id;
    contactoModel.type = data.type;
    const { attributes } = data;
    if (attributes.title) {
      contactoModel.title = attributes.title;
    }
    if (attributes.dni_contacto) {
      contactoModel.dni = attributes.dni_contacto;
    }
    if (attributes.email) {
      contactoModel.email = attributes.email;
    }
    if (attributes.nombre_contacto) {
      contactoModel.nombre = attributes.nombre_contacto;
    }
    if (attributes.apellidos_contacto) {
      contactoModel.apellidos = attributes.apellidos_contacto;
    }
    if (attributes.cargo_contacto) {
      contactoModel.cargo = attributes.cargo_contacto;
    }
    if (attributes.tel1) {
      contactoModel.tel1 = attributes.tel1;
    }
    if (attributes.tel2) {
      contactoModel.tel2 = attributes.tel2;
    }
  }
  return contactoModel;
};

export const processClient = (data, included) => {
  const clientModel = {};
  if (data) {
    clientModel.id = data.id;
    clientModel.type = data.type;
    const { attributes, relationships } = data;
    // attributes
    if (attributes.dni) {
      clientModel.dni = attributes.dni;
    }
    if (attributes.nombre) {
      clientModel.nombre = attributes.nombre;
    }
    if (attributes.apellidos) {
      clientModel.apellidos = attributes.apellidos;
    }
    if (attributes.apellidos) {
      clientModel.apellidos = attributes.apellidos;
    }
    if ('deudor' in attributes) {
      clientModel.deudor = attributes.deudor ? 1 : 0;
    }
    if ('hipotecante' in attributes) {
      clientModel.hipotecante = attributes.hipotecante ? 1 : 0;
    }
    if (attributes.direccion) {
      clientModel.direccion = attributes.direccion;
    }
    if (attributes.codigo_postal_cliente) {
      clientModel.cp = attributes.codigo_postal_cliente;
    }
    if (attributes.poblacion) {
      clientModel.poblacion = attributes.poblacion;
    }
    if (attributes.provincia) {
      clientModel.provincia = attributes.provincia;
    }
    if (attributes.tlfno_1) {
      clientModel.tel1 = attributes.tlfno_1;
    }
    if (attributes.tlfno_2) {
      clientModel.tel2 = attributes.tlfno_2;
    }
    if (attributes.e_mail) {
      clientModel.email = attributes.e_mail;
    }
    if (attributes.comentario) {
      clientModel.observaciones = attributes.comentario;
    }
    if (attributes.rating) {
      clientModel.rating = attributes.rating;
    }
    // relationships
    if (relationships.person && relationships.person.data) {
      clientModel.tipo = relationships.person.data.id;
    }
    if (relationships.civil_state && relationships.civil_state.data) {
      clientModel.estadoCivil = relationships.civil_state.data.id;
    }
    if (relationships.civil_state && relationships.civil_state.data) {
      clientModel.estadoCivil = relationships.civil_state.data.id;
    }
    if (relationships.contacto && relationships.contacto.data) {
      clientModel.contacto = included.contact;
    }
    if (relationships.reputations && relationships.reputations.data) {
      clientModel.reputations = included.reputations;
    }
    return clientModel;
  }
  return null;
};

export const processClientIncluded = (client, included) => {
  let contact = null;
  const relationships = client.relationships;
  const reputations = [];
  let tipo = null;
  let estadoCivil = null;
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--contacto') {
        if (relationships &&
          relationships.contacto &&
          relationships.contacto.data &&
          relationships.contacto.data.id === rel.id) {
          contact = processContact(rel);
        }
      }
      if (rel.type === 'node--online_reputation') {
        if (relationships &&
          relationships.reputations &&
          relationships.reputations.data &&
          relationships.reputations.data.length > 0) {
          relationships.reputations.data.forEach((r) => {
            if (r.id === rel.id) {
              reputations.push(processReputation(rel));
            }
          });
        }
      }
      if (rel.type === 'taxonomy_term--civil_state') {
        if (relationships &&
          relationships.civil_state &&
          relationships.civil_state.data &&
          relationships.civil_state.data.id === rel.id) {
          estadoCivil = { id: rel.id, value: rel.attributes.name };
        }
      }
      if (rel.type === 'taxonomy_term--person') {
        if (relationships.person &&
          relationships.person.data &&
          relationships.person.data.id === rel.id) {
          tipo = { id: rel.id, value: rel.attributes.name };
        }
      }
    });
    return { contact, reputations, estadoCivil, tipo };
  }
  return null;
};

export const processContactResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(c => processContact(c));
  }
  return processContact(res.data.data);
};

export const processClientResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(c => processClient(c, processClientIncluded(c, res.data.included)));
  }
  const included = processClientIncluded(res.data.data, res.data.included);
  return processClient(res.data.data, included);
};

export const processReputationResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(r => processReputation(r, processReputationIncluded(r, res.data.included)));
  }
  return processReputation(res.data.data, processReputationIncluded(res.data.data, res.data.included));
};
export const processOperationsByClient = (res, client) => {
  const obj = {};
  obj[client] = [];
  res.data.data.forEach((operation) => {
    if (operation.relationships && operation.relationships.state) {
      const state = operation.relationships.state;
      if (state && state.data && state.data.id) {
        const stateId = state.data.id;
        operation.attributes.state = stateId;
      }
    }
    obj[client].push(operation.attributes);
  });
  return obj;
};



// WEBPACK FOOTER //
// ./src/features/tab-cliente/utils.js